export const gdpr = {
  routes: [
    {
      path: "/gdpr/minimization",
      component: () => import("../minimization"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/minimization",
      component: () => import("../minimization"),
    },
  ],
};
